import MessageBusTopics from '../../common/MessageBusTopics';
import Login from './Login';

const localStorageBettingTvKey = 'Channel';

const select = {
    manageBettingTvChannelState: function (channel, localStorageTrigger, isLoggedIn) {
        if (!channel) {
            this.hidePlayer();
        } else if (Login.isLoggedIn() || isLoggedIn) {
            window.localStorage.setItem(localStorageBettingTvKey, channel);
            this.triggerChannelChange(channel);
            this.showPlayer();
        } else {
            window.localStorage.setItem(localStorageBettingTvKey, channel);
            this.hidePlayer();
            if (!localStorageTrigger) {
                window.WH.messageBus.publish('wh.common.command.ui.login.flow.start');
            }
        }
    },
    mapChannelName: function (channel) {
        let mappedName = '';
        switch (channel) {
        case 'bstv1':
            mappedName = 'Betting TV 1';
            break;
        case 'bstv2':
            mappedName = 'Betting TV 2';
            break;
        case 'bstv3':
            mappedName = 'Betting TV 3';
            break;
        default:
            mappedName = channel;
            break;
        }
        return mappedName;
    },
    hidePlayer: function() {
        document.querySelector('.whtv-mobile-container').style.display = 'none';
        const videoElement = document.querySelector('.william-hill-tv-player-node.video-js');
        if (videoElement) {
            videoElement.classList.remove('theo-mobile');
        }
        const body = document.querySelector('body');
        body.classList.remove('whtv-on');
    },
    showPlayer: function() {
        this.addMobileClass();
        document.querySelector('.whtv-mobile-container').style.display = 'block';
    },
    triggerChannelChange: function(channel) {
        let selectElement = document.querySelector('#channelSelectDropwdown');
        let nativeInputValueSetter = Object.getOwnPropertyDescriptor(
            window.HTMLSelectElement.prototype,
            'value'
        ).set;
        nativeInputValueSetter.call(selectElement, this.mapChannelName(channel));
        let event = new Event('change', { bubbles: true });
        selectElement.dispatchEvent(event);
    },
    onGetLoginState: function() {
        window.WH.messageBus.subscribe(
            MessageBusTopics.GOT_LOGIN_STATE,
            function (__, state) {
                const channelCacheKey = localStorage.getItem(localStorageBettingTvKey);
                if (channelCacheKey) {
                    let retriesCount = 0;
                    const maxRetries = 50;
                    /*
                    * interval handles navigation from the ngs site
                    * dolby player should be run if it was run before (ngs)
                    * not all sources are loaded yet so that we check source
                    */
                    const intervalID = setInterval(() => {
                        retriesCount ++;
                        if (performance.getEntries().map(e => e.name).find(n => n.includes('whtv')
                        && document.querySelector('#channelSelectDropwdown') && retriesCount <= maxRetries)
                        ) {
                            clearInterval(intervalID );
                            select.manageBettingTvChannelState(channelCacheKey, true, state.isLoggedIn);
                            if (!state.isLoggedIn) {
                                select.handleLogoutAction();
                            }
                        }
                        if (retriesCount > maxRetries) {
                            clearInterval(intervalID );
                        }
                    }, 200);
                }
            }
        );
    },
    observeSidebarChannelChange: function() {
        window.WH.messageBus.subscribe(
            MessageBusTopics.BETTING_TV_CHANNEL,
            function (__, newChannel) {
                select.manageBettingTvChannelState(newChannel, false);
            }
        );
    },
    addMobileClass: function () {
        const adjustMobileMargins = this.adjustAbsolutHeaderPanelMargin;
        const observer = new MutationObserver(function(mutations_list) {
            mutations_list.forEach(function(mutation) {
                mutation.addedNodes.forEach(function(__, i) {
                    if (i === 0) {
                        observer.disconnect();
                        setTimeout(() => {
                            const videoElement = document.querySelector('.william-hill-tv-player-node.video-js');
                            videoElement.classList.add('theo-mobile');
                            adjustMobileMargins();
                        }, 2500);
                    }
                });
            });
        });

        observer.observe(document.querySelector('.whtv-mobile-container'), { subtree: true, childList: true });
    },
    /*
    * Some of pages (for example: betting/en-gb/cricket/matches)
    * have toolbar icons (header panel) positioned to the breadcrumbs section (rendered by another service)
    * with position absolute and top margin refered to the window.
    * Because of that a toolbar icon would be covered by the player
    */
    adjustAbsolutHeaderPanelMargin: function() {
        if (!document.body.classList.contains('whtv-on')) {
            const style = document.createElement('style');
            style.appendChild(document.createTextNode(''));
            document.head.appendChild(style);
            const body = document.querySelector('body');
            body.classList.add('whtv-on');
            const videoHeight = document.getElementById('william-hill-tv-container-node').offsetHeight;
            const defaultTopAbsolutMargin = 45;
            const topMargin = videoHeight + defaultTopAbsolutMargin;
            style.sheet.insertRule(
                `body.whtv-on #main .column__primary--breadcrumbs-aligned .header-panel {top:${topMargin}px;}`, 0
            );
        }
    },
    handleLogoutAction: function () {
        if (window.WH && typeof window.WH.StreamPlayer === 'function') {
            window.WH.messageBus.publish('mediaplayers.whtv.stop');
        }
    },
};

/**
 * Public functions.
 *
 */
var api = {
    /**
   * Initialisation.
   *
   * @returns {void}
   *
   * @public
   */

    init: function () {
        select.onGetLoginState();
        select.observeSidebarChannelChange();
    },
};

export default api;
